import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getDedicatedNumber } from '../../../accounts/DedicatedNumber/DedicatedNumberSlice/DedicatedNumberSlice'
import GiphyPopup from '../../../../Common/GiphyPopup/GiphyPopup'
import Select from 'react-select'
import { countWords } from '../../../../../../_metronic/helpers'
import MessageBoxV2 from '../../../../../Components/MessageBoxV2'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { BulkMsgDraftData } from '../../BulkMessageSlice/BulkMessageSlice'
import { DEFAULT_REPLY_STOP_OUT_COUNT, fileToBase64, processData, replaceMessageWith } from '../../../../../Utils/_helpers'
import { globalSettingsTypes } from '../../../../../Utils/Constant/status'
import { getAllUserDetails, getDefaultOptOutUrlCount, getDefaultShortUrl } from '../../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import { useNewMessage } from '../../useNewMessage'
import MessageBoxSecondV2 from '../../../../../Components/MessageBoxSecondV2'
import FilterTag from '../../../Contacts/Components/FilterTag'
import { GLOBAL_SETTINGS_TYPE } from '../../../../../Utils/Constant/ConstantForWebsite'
import { ENV } from '../../../../../Utils/_helpers/EnvHelper'


const MAX_FILE_SIZE = 1572864 //1048576;

const Bulk_Message_MesssageBox_V2 = ({
  bulkMessageData,
  setBulkMessageData,
  checkStep,
  setMMSError,
  error,
  setError,
  setCheckStep,
  setIsForwardIncomingMessage
}: any) => {

  const dispatch = useDispatch()
  const DedicatedNumber: any = useSelector(getDedicatedNumber)
  const userGlobalSetting = useSelector(
    (state: any) => state?.userDetails?.userDetails?.data?.user?.globalSetting
  )
  const userValues = useSelector(getAllUserDetails)
  const { isDefaultRegion } = useNewMessage()
  const defaultDomain = useSelector(getDefaultShortUrl)
  const defaultStopUrlCount = useSelector(getDefaultOptOutUrlCount)

  const mediaInput: any = useRef(null)
  const mediaInputVideo: any = useRef(null)

  const hasCustomPriceSetting =
    userGlobalSetting && userGlobalSetting?.includes(globalSettingsTypes.SEND_WITH_CUSTOM_PRICE)
  const isSenderBusinessNameOrCustomNumber =
    bulkMessageData?.senderType === 'businessName' || bulkMessageData?.senderType === 'customNumber'

  const isCustomPriceOrAlphaId = hasCustomPriceSetting
    ? isSenderBusinessNameOrCustomNumber
    : !userGlobalSetting && isSenderBusinessNameOrCustomNumber

  const [giphypopup, setGiphypopup] = useState<any>(false)
  const [popup, setPopup] = useState(false)
  const [uploadLimit, setUploadLimit] = useState('')
  const [options, setOptions] = useState({
    webLink: [
      {
        value: '',
        label: (
          <button
            onClick={() => {
              setPopup(true)
            }}
          >
            Create
          </button>
        ),
      },
    ],
    customLanding: [
      {
        value: '',
        label: (
          <button
            onClick={() => {
              window.open('/create-langing-page')
            }}
          >
            Create
          </button>
        ),
      },
    ],
    optOut: [
      {
        value: '',
        label: (
          <button
            onClick={() => {
              window.open('/opt-out')
            }}
          >
            Create
          </button>
        ),
      },
      { value: 'ReplyStop', label: 'Reply Stop' },
    ],
  })
  const optoutCount = bulkMessageData.optout === true ? defaultStopUrlCount : 0
  const replyStopToOptOutCount = bulkMessageData?.replyStopToOptOut === true ? DEFAULT_REPLY_STOP_OUT_COUNT : 0

  const optoutCountSecond = bulkMessageData.optoutSecond === true ? defaultStopUrlCount : 0
  const replyStopToOptOutCountSecond = bulkMessageData.replyStopToOptOutSecond === true ? DEFAULT_REPLY_STOP_OUT_COUNT : 0

  let shortUrlCount = 0
  let shourtUrlCountSecond = 0

  if (bulkMessageData?.longUrl?.length > 0) {
    const uniqueUrl = Array.from(new Map(bulkMessageData.longUrl.map((item: any) => [item.shortUrl, item])).values())

    for (let index = 0; index < uniqueUrl.length; index++) {
      const element: any = uniqueUrl[index];
      let tempShortUrl = `${defaultDomain}/${element.shortUrl}`

      if (bulkMessageData?.message.split(tempShortUrl).length - 1) {
        shortUrlCount += (bulkMessageData?.message.split(tempShortUrl).length - 1) * 6
      }
    }
  }

  if (bulkMessageData?.longUrlSecond?.length > 0) {
    const uniqueUrl = Array.from(new Map(bulkMessageData.longUrlSecond.map((item: any) => [item.shortUrl, item])).values())

    for (let index = 0; index < uniqueUrl.length; index++) {
      const element: any = uniqueUrl[index];
      let tempShortUrl = `${defaultDomain}/${element.shortUrl}`

      if (bulkMessageData?.messageSecond.split(tempShortUrl).length - 1) {
        shourtUrlCountSecond += (bulkMessageData?.messageSecond.split(tempShortUrl).length - 1) * 6
      }
    }
  }

  const messageCount = processData(
    bulkMessageData?.message ?? '',
    replyStopToOptOutCount + optoutCount + shortUrlCount,
    isCustomPriceOrAlphaId
  )

  const messageCountSecond = processData(
    bulkMessageData?.messageSecond  ?? '',
    replyStopToOptOutCountSecond + optoutCountSecond + shourtUrlCountSecond,
    isCustomPriceOrAlphaId
  )

  const getSubtitle = () => {
    if (bulkMessageData?.message?.length > 0) {
      return `${(bulkMessageData.camp_type === 'sms') !== true
        ? 1
        : messageCount?.credit
        } ${bulkMessageData.camp_type?.toUpperCase()} Credits. ${bulkMessageData?.abTest === true ? ' A/B Testing' : ''
        }`
    } else {
      return 'Compose the content for your message'
    }
  }

  const detectMediaType = (media: any): string => {
    if (!media) return ''

    // Handle File object case
    if (media instanceof File) {
      if (media.type === 'image/gif' || media.name?.toLowerCase().endsWith('.gif')) {
        return 'GIF'
      }
      return 'Media'
    }

    // Handle Giphy URL case
    if (typeof media === 'string' && media.includes('giphy.com')) {
      return 'GIF'
    }

    if (typeof media === 'string' && /\.(jpe?g|png|webp)$/i.test(media)) {
      return 'Media'
    }

    // Handle object with properties
    if (typeof media === 'object') {
      // Check if it's a GIF by examining the filetype
      if (media.filetype && media.filetype.toLowerCase() === 'image/gif') {
        return 'GIF'
      }

      // Check URL for giphy source
      if (media.url && media.url.includes('giphy.com')) {
        return 'GIF'
      }

      // Check URL extension
      if (media.url) {
        const url = media.url.toLowerCase()
        if (url.endsWith('.gif')) {
          return 'GIF'
        }
        if (/\.(jpe?g|png|webp)$/i.test(url)) {
          return 'Media'
        }
        if (/\.(mp4|mov|webm)$/i.test(url)) {
          return 'Media'
        }
      }

      // Check fileName
      if (media.fileName && media.fileName.toLowerCase().endsWith('.gif')) {
        return 'GIF'
      }

      // If it has url or filetype but not identified as specific type
      if (media.url || media.filetype) {
        return 'Media'
      }
    }

    return ''
  }

  const extractMediaName = (media: any): string => {
    if (!media) return ''

    // Handle File object case
    if (media instanceof File) {
      return media.name || 'Media File'
    }

    // Handle string URL case
    if (typeof media === 'string') {
      const urlParts = media?.split('/')
      const potentialFilename = urlParts[urlParts.length - 1]
      const filenameParts = potentialFilename?.split('?')
      return filenameParts[0] || 'Media File'
    }

    // Handle object with properties
    if (typeof media === 'object') {
      // First priority: use fileName if available
      if (media.fileName) {
        return media.fileName
      }

      // Second priority: extract from URL
      if (media.url) {
        const urlParts = media?.url?.split('/')
        const potentialFilename = urlParts[urlParts.length - 1]
        const filenameParts = potentialFilename?.split('?')
        return filenameParts[0] || 'Media File'
      }

      // Third priority: use filetype to generate generic name
      if (media.filetype) {
        if (media.filetype.toLowerCase() === 'image/gif') {
          return 'GIF'
        } else {
          // Extract the subtype from mime type (e.g. 'jpeg' from 'image/jpeg')
          const parts = media?.filetype?.split('/')
          if (parts.length > 1) {
            return `${parts[1].toUpperCase()} File`
          }
        }
      }
    }

    // Default fallback
    return 'Media File'
  }

  return (
    <>
      <GiphyPopup
        data={bulkMessageData}
        setData={setBulkMessageData}
        show={giphypopup}
        bulkMessage={true}
        handleClose={() => {
          setGiphypopup(false)
        }}
      />
      <h2
        className={`accordion-header ${bulkMessageData.message !== '' && bulkMessageData.camp_type !== '' && 'successData'
          }`}
        id='headingfour'
      >
        <button
          className='collapsed accordion-button'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapsefour'
          aria-expanded='false'
          aria-controls='collapsefour'
          onClick={() => {
            setCheckStep({
              gettingStarted: false,
              to: false,
              from: false,
              message: !checkStep.message,
              when: false,
            })
          }}
        >
          <div className='d-flex flex-column align-items-start gap-1'>
            <span className={checkStep?.message ? 'text-primary' : ''}>Message</span>
            <span className='accordion-subtitle fs-6 fw-normal lh-base'>{getSubtitle()}</span>
          </div>
        </button>
        <div className='bulk-message-collapse'>
          {bulkMessageData?.message?.length > 0 ? (
            <div
              className='accordion-title-detail small'
              style={{ color: `${bulkMessageData?.message?.length > 0 ? '#1A1C37' : ''}` }}
            >
              {bulkMessageData?.abTest === true && <strong className='mb-2'>Message A: </strong>}
              {(bulkMessageData.camp_type === 'sms') !== true ? (
                <label>{`${
                  // countWords(bulkMessageData?.message) + replyStopToOptOutCount + optoutCount
                  countWords(bulkMessageData?.message) + replyStopToOptOutCount + optoutCount + shortUrlCount
                  }/1000`}</label>
              ) : (
                <label>{`${messageCount?.maxdata - messageCount?.length
                  }/${messageCount?.maxdata
                  }`}</label>
              )}{' '}
              Characters
            </div>
          ) : (
            <div className='accordion-title-detail small'>Your message type</div>
          )}

          {bulkMessageData?.abTest === true && (
            <>
              {bulkMessageData?.messageSecond?.length > 0 ? (
                <div
                  className='accordion-title-detail small'
                  style={{ color: `${bulkMessageData?.messageSecond?.length > 0 ? '#1A1C37' : ''}` }}
                >
                  <strong className='mb-2'>Message B: </strong>
                  {bulkMessageData.camp_type === 'sms' && (
                    <label>{`${messageCountSecond?.maxdata - messageCountSecond?.length
                      }/${messageCountSecond?.maxdata
                      }`}</label>
                  )}{' '}
                  Characters
                </div>
              ) : (
                <div className='accordion-title-detail small'>Write your second message</div>
              )}
            </>
          )}
        </div>
      </h2>
      <div
        id='collapsefour'
        className={`accordion-collapse collapse ${checkStep.message && 'show'}`}
        aria-labelledby='headingfour'
        data-bs-parent='#accordionExample'
      >
        <div className='accordion-body'>
          <div className='d-flex mb-2'>
            <div
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              title={
                Array.isArray(DedicatedNumber) &&
                DedicatedNumber?.find(
                  (key: any) => key.audNumber === bulkMessageData.sender?.value
                )?.type?.toLowerCase() === 'mms'
                  ? 'To select SMS , First select from Dedicated  number of type SMS '
                  : ''
              }
              className='w-auto me-3 mw-150px'
            >
              <input
                type='radio'
                className='btn-check'
                name='radio_buttons_2'
                value='sms'
                id='kt_radio_buttons_2_option_2'
                checked={bulkMessageData.camp_type === 'sms'}
                onChange={() => {
                  let tempData = {
                    ...bulkMessageData,
                    camp_type: 'sms',
                    optoutLabel: '',
                    optoutId: '',
                  }
                  if (bulkMessageData.senderType === 'dedicatedNumber') {
                    tempData = {
                      ...tempData,
                    }
                  }
                  setBulkMessageData(tempData)

                  dispatch(
                    BulkMsgDraftData({
                      ...tempData,
                      scheduledAt: '',
                    })
                  )
                }}
              />
              <label
                className='d-flex btn btn-outline btn-outline-dashed btn-outline-default align-items-center justify-content-center p-4 px-7'
                htmlFor='kt_radio_buttons_2_option_2'
                data-testid='btnSMSMessage'
              >
                SMS
              </label>
            </div>
            <div
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              title={
                Array.isArray(DedicatedNumber) &&
                DedicatedNumber?.find(
                  (key: any) => key.audNumber === bulkMessageData.sender?.value
                )?.type?.toLowerCase() === 'sms'
                  ? 'To select MMS , First select from Dedicated  number of type MMS  '
                  : ''
              }
              className='w-auto mw-150px'
            >
              <input
                type='radio'
                className='btn-check'
                name='radio_buttons_2'
                value='apps'
                id='kt_radio_buttons_2_option_1'
                disabled={
                  Array.isArray(DedicatedNumber) &&
                  DedicatedNumber?.find(
                    (key: any) => key.audNumber === bulkMessageData.sender?.value
                  )?.type?.toLowerCase() === 'sms'
                }
                checked={bulkMessageData.camp_type === 'mms'}
                onChange={() => {
                  let tempData = {
                    ...bulkMessageData,
                    camp_type: 'mms',
                    optoutLabel: '',
                    optoutId: '',
                  }
                  if (
                    bulkMessageData.senderType === 'businessName' ||
                    bulkMessageData.senderType === 'customNumber' ||
                    bulkMessageData.senderType === 'dedicatedNumber'
                  ) {
                    if (
                      Array.isArray(DedicatedNumber) &&
                      DedicatedNumber?.find(
                        (key: any) => key.audNumber === bulkMessageData.sender?.value
                      )?.type?.toLowerCase() === 'sms'
                    ) {
                      tempData.sender = ''
                      tempData.senderType = ''

                      setError({ ...error, sender: 'Select sender  is required' })
                      setMMSError(true)
                    }
                  }
                  setBulkMessageData(tempData)
                  dispatch(
                    BulkMsgDraftData({
                      ...tempData,
                      scheduledAt: '',
                    })
                  )
                }}
              />
              {isDefaultRegion ? (
                <OverlayTrigger
                  placement='top'
                  overlay={
                    <Tooltip id='button-tooltip'>
                      MMS can not be sent with customer business name or your own number
                    </Tooltip>
                  }
                >
                  <div className='d-flex gap-2 justify-content-center align-items-center'>
                    <label
                      className='d-flex btn btn-outline btn-outline-dashed btn-outline-default align-items-center justify-content-center p-4 px-7'
                      htmlFor='kt_radio_buttons_2_option_1'
                      data-testid='btnMMSMessage'
                    >
                      MMS
                    </label>
                    {['businessName', 'customNumber'].includes(bulkMessageData.senderType) && (
                      <i
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        className='bi bi-exclamation-circle-fill'
                      ></i>
                    )}
                  </div>
                </OverlayTrigger>
              ) : null}
            </div>
          </div>
          <div className='tab-content' id='myTabContent'>
            <div
              className='active fade show tab-pane'
              id='sms'
              role='tabpanel'
              aria-labelledby='sms-tab'
            >
              {bulkMessageData?.camp_type === 'mms' && (
                <>
                  <div className='col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12'>
                    <div className='mt-0'>
                      <label className='form-label'>Subject line</label>
                      <input
                        type='text'
                        data-testid='inputSubjectMMS'
                        className='form-control form-control-lg form-control-solid'
                        placeholder='Type optional subject line here'
                        value={bulkMessageData?.subject}
                        onChange={(e: any) => {
                          setBulkMessageData({ ...bulkMessageData, subject: e?.target?.value })
                          dispatch(
                            BulkMsgDraftData({
                              ...bulkMessageData,
                              scheduledAt: '',
                              subject: e?.target?.value,
                            })
                          )
                        }}
                      />
                    </div>
                  </div>
                  <div className='col-12 mb-4 mt-8'>
                    <div className='d-flex flex-row w-100 gap-3'>
                      <div className='d-flex flex-column w-100'>
                        <label className='form-label'>Media</label>
                        <div className='input-tags-container'>
                          {(bulkMessageData?.media !== '' || bulkMessageData.gif !== '') && (
                            <FilterTag
                              column={detectMediaType(bulkMessageData?.media) || 'GIF'}
                              value={
                                extractMediaName(bulkMessageData?.media) ||
                                bulkMessageData?.gif?.split('/')?.pop()?.split('?')[0]
                              }
                              onClose={() => {
                                mediaInput.current.value = null
                                mediaInputVideo.current.value = null
                                setBulkMessageData({ ...bulkMessageData, media: '', gif: '' })
                                dispatch(
                                  BulkMsgDraftData({
                                    ...bulkMessageData,
                                    scheduledAt: '',
                                    media: '',
                                    gif: '',
                                  })
                                )
                              }}
                            />
                          )}
                        </div>

                        <p
                          style={{
                            whiteSpace: 'nowrap',
                          }}
                          className='m-0 text-muted pt-2'
                        >
                          File size should be less than 1.5 MB.
                        </p>
                      </div>

                      <div className='d-flex flex-column justify-content-center media_dropdown'>
                        <input
                          ref={mediaInput}
                          accept={'.jpeg,.png,.vcf'}
                          type='file'
                          name='file'
                          data-testid='inputUploadMedia'
                          style={{ display: 'none' }}
                          onChange={async (e: any) => {
                            let data = e.target.files[0]
                            let err = { ...error }
                            delete err?.media
                            data?.size > MAX_FILE_SIZE &&
                              setError({
                                ...error,
                                media: 'Upload size should be less than 1.5mb',
                              })
                            if (data && data?.size < MAX_FILE_SIZE) {
                              let base64String = bulkMessageData?.media ?? ''
                              if (!!data && !(typeof data == 'string')) {
                                base64String = await fileToBase64(data)
                              }
                              setBulkMessageData({ ...bulkMessageData, media: data, gif: '' })
                              dispatch(
                                BulkMsgDraftData({
                                  ...bulkMessageData,
                                  scheduledAt: '',
                                  media: base64String,
                                  gif: '',
                                })
                              )
                            }
                            setError(err)
                          }}
                        />
                        <input
                          ref={mediaInputVideo}
                          accept={'.jpeg,.png,.jpg,.gif,.mp4,.mp3,video/*,.vcf'}
                          type='file'
                          name='file'
                          data-testid='inputUploadGif'
                          style={{ display: 'none' }}
                          onChange={async (e: any) => {
                            let data = e.target.files[0]
                            let err = { ...error }
                            delete err?.media

                            data?.size > MAX_FILE_SIZE &&
                              setError({
                                ...error,
                                media: 'Upload size should be less than 1.5mb',
                              })

                            if (data && data?.size < MAX_FILE_SIZE) {
                              let base64String = bulkMessageData?.media ?? ''
                              if (!!data && !(typeof data == 'string')) {
                                base64String = await fileToBase64(data)
                              }
                              setBulkMessageData({ ...bulkMessageData, media: data, gif: '' })
                              dispatch(
                                BulkMsgDraftData({
                                  ...bulkMessageData,
                                  scheduledAt: '',
                                  media: base64String,
                                  gif: '',
                                })
                              )
                              setError(err)
                            }
                          }}
                        />
                        <Select
                          value={{ value: '', label: 'Add Media' }}
                          placeholder='Add Media'
                          isSearchable={false}
                          onChange={(e: any) => {
                            // if (e.value == '1') {
                            //   mediaInput.current.click()
                            // }
                            if (e.value == '1') {
                              mediaInputVideo.current.click()
                            }
                            if (e.value == '3') {
                              setGiphypopup(true)
                            }
                          }}
                          options={[
                            { value: '1', label: 'Upload File' },
                            // {value: '2', label: 'Upload video'},
                            { value: '3', label: 'Select GIPHY' },
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                  {error?.media && (
                    <p style={{ color: 'red' }} className='mb-2'>
                      {error?.media}
                    </p>
                  )}
                </>
              )}

              <MessageBoxV2
                error={error}
                setError={setError}
                setUserMessage={setBulkMessageData}
                userMessage={bulkMessageData}
                setOptions={setOptions}
                options={options}
                isDraft={true}
                isAlphaId={isCustomPriceOrAlphaId}
                showSelect={['template', 'customfield', 'weblink', 'landingPage', 'opt-out']}
                quickSms={bulkMessageData.camp_type === 'sms'}
                setIsForward={setIsForwardIncomingMessage}
                enableUnicodeModal={true}
              />

              {isDefaultRegion && bulkMessageData.camp_type === 'sms' && (
                <div>
                  <div className='form-check form-check-custom form-check-sm form-check-solid mt-2'>
                    <input
                      className='form-check-input me-5'
                      id='abtest'
                      type='checkbox'
                      data-kt-check='true'
                      checked={bulkMessageData.abTest}
                      disabled={userValues?.smsStatus !== 'approved'}
                      onChange={() => {
                        setBulkMessageData({
                          ...bulkMessageData,
                          abTest: !bulkMessageData.abTest,
                        })
                      }}
                    />
                    <div>
                      <div className='d-flex'>
                        <h5 style={{ lineHeight: '0.65' }}>A/B Testing</h5>
                        <OverlayTrigger
                          placement='top'
                          overlay={<Tooltip>Contact Support to enable A/B Testing</Tooltip>}
                        >
                          {userValues?.smsStatus !== 'approved' ? (
                            <i
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              title='A/B Testing'
                              className='bi bi-question-circle-fill px-3'
                            ></i>
                          ) : (
                            <></>
                          )}
                        </OverlayTrigger>
                      </div>
                      <p>Set A/B Testing for this campaign</p>
                    </div>
                  </div>
                </div>
              )}

              {bulkMessageData.camp_type === 'sms' && bulkMessageData.abTest && (
                <MessageBoxSecondV2
                  error={error}
                  setError={setError}
                  setUserMessage={setBulkMessageData}
                  userMessage={bulkMessageData}
                  setOptions={setOptions}
                  options={options}
                  isDraft={true}
                  isAlphaId={isCustomPriceOrAlphaId}
                  showSelect={['template', 'customfield', 'weblink', 'landingPage', 'opt-out']}
                  quickSms={bulkMessageData.camp_type === 'sms'}
                />
              )}

              {bulkMessageData.autoResponder && (
                <div className='row'>
                  <div className='col-md-7 ps-14'>
                    <select name='selector' className='form-select bg-light-primary border-0 mt-3'>
                      <option value=''>Select your Automation</option>
                      <option value='1'>Reply Y</option>
                      <option value='2'>Any message</option>
                      <option value='3'>VIP</option>
                    </select>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Bulk_Message_MesssageBox_V2
